import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLinkIcon, BadgeCheckIcon } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
interface GpsBrand {
  name: string;
  description: string;
  tagline: string;
}
const brands: GpsBrand[] = [{
  name: 'Queclink',
  description: 'Líder mundial en telemática vehicular con más de 15 años de experiencia. Dispositivos de alta durabilidad y cobertura global.',
  tagline: 'Líder Global en Telemática'
}, {
  name: 'JIMI IoT',
  description: 'Innovación IoT para rastreo personal, vehicular y de activos. Soluciones versátiles para cada necesidad de monitoreo.',
  tagline: 'Innovación IoT Avanzada'
}, {
  name: 'Suntech',
  description: 'Soluciones GPS robustas diseñadas para transporte pesado y flotas exigentes. Máxima confiabilidad en condiciones extremas.',
  tagline: 'Robustez Industrial'
}];
export function GpsHardwareSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section id="gps" ref={ref} className="w-full bg-brand-primary py-20 md:py-28" data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-139">
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-4" data-id="element-140">
            Hardware GPS de clase mundial
          </h2>
          <p className="font-body text-lg text-brand-text-secondary max-w-2xl mx-auto" data-id="element-141">
            Distribuimos y certificamos los mejores dispositivos del mercado
          </p>
        </motion.div>

        {/* Brand Cards */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 mb-12" data-id="element-142">
          {brands.map((brand, index) => <motion.div key={brand.name} initial={{
          opacity: 0,
          y: 30
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="group" data-id="element-143">
              <div className="h-full glass rounded-2xl p-6 md:p-8 border border-cyan-subtle hover:border-brand-accent/50 transition-all duration-300 group-hover:-translate-y-2" data-id="element-144">
                {/* Brand Header */}
                <div className="flex items-start justify-between mb-4" data-id="element-145">
                  <div data-id="element-146">
                    <h3 className="font-heading font-bold text-2xl text-white mb-1" data-id="element-147">
                      {brand.name}
                    </h3>
                    <p className="font-mono text-xs text-brand-accent" data-id="element-148">
                      {brand.tagline}
                    </p>
                  </div>
                  <div className="w-10 h-10 rounded-lg bg-brand-accent/10 flex items-center justify-center" data-id="element-149">
                    <BadgeCheckIcon className="w-5 h-5 text-brand-accent" data-id="element-150" />
                  </div>
                </div>

                {/* Description */}
                <p className="font-body text-brand-text-secondary mb-6" data-id="element-151">
                  {brand.description}
                </p>

                {/* Footer */}
                <div className="flex items-center justify-between" data-id="element-152">
                  <a href="#contacto" className="inline-flex items-center gap-2 font-subheading text-sm text-brand-accent hover:text-white transition-colors" data-id="element-153">
                    Ver Dispositivos
                    <ExternalLinkIcon className="w-4 h-4" data-id="element-154" />
                  </a>
                  <span className="font-mono text-[10px] text-brand-text-secondary px-2 py-1 bg-brand-surface rounded" data-id="element-155">
                    Distribuidor Autorizado
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Wholesale CTA */}
        <motion.div initial={{
        opacity: 0
      }} animate={isVisible ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center" data-id="element-156">
          <p className="font-body text-brand-text-secondary mb-4" data-id="element-157">
            ¿Eres empresa distribuidora?
          </p>
          <a href="#contacto" className="inline-flex items-center gap-2 font-subheading font-semibold text-brand-accent hover:text-white transition-colors border-b border-brand-accent hover:border-white pb-1" data-id="element-158">
            Contáctanos para mayoreo
            <ExternalLinkIcon className="w-4 h-4" data-id="element-159" />
          </a>
        </motion.div>
      </div>
    </section>;
}